module.exports = "//static.hsappstatic.net/growth-onboarding-confetti/static-1.660/images/sprocket.svg"